


import "./App.css";
import React from "react";
const App = () => {


  return (
    <div className="relative flex italic flex-col  justify-evenly items-center text-9xl  text-black  bg-[url('/src/asset/bg6.jfif')] bg-cover  min-h-96 overflow-hidden h-screen">
      404
    </div>
  );
};


export default App;
